import { faEdit } from '~components/icon';
import { Column } from '~components/table-view';
import { linkCellRender } from '~components/table-view/columnRenderers';
import PricePlanActions from '~support-at-home/components/config/price-plans/PricePlanActions';

const columnsFactory = (togglePricePlanModal: (id: string) => void, onCopyPricePlan: (id: string) => void) => {
  const columns: Column[] = [
    {
      id: 'name',
      header: 'Plan Name',
      type: 'text',
      renderReadOnly: linkCellRender((row) => togglePricePlanModal(row.id), faEdit),
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'date',
    },
    {
      id: 'end_date',
      header: 'End Date',
      type: 'date',
    },
    {
      id: 'revision_id',
      header: 'Revision',
      type: 'text',
      deriveValue: (row) => `Version ${row.latest_revision}`,
    },
    {
      id: 'actions',
      header: 'Actions',
      type: 'custom',
      classNames: { header: 'text-end', cell: 'text-end' },
      component: PricePlanActions,
      componentProps: () => ({ onCopy: onCopyPricePlan }),
    },
  ];

  return columns;
};

export default columnsFactory;
